/**
 * ColorPickerTypes 
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum COLOR_CODE_TYPE {
	HEX = "hex",
	HSLA = "hsla",
	RGBA = "rgba"
}

export interface IAlpha {
	a: number;
}

export type HEX = `#${number | string}`;

export interface IRGB {
	r: number;
	g: number;
	b: number;
}

export interface IRGBA extends IRGB, IAlpha {}

export interface IHSL {
	h: number;
	s: number;
	l: number;
}

export interface IHSLA extends IHSL, IAlpha {}

export type ColorInput = IRGB | IRGBA | IHSL | IHSLA | HEX;
